<template>
    <div v-cloak class="no-data-component">
        <i :class="icon" aria-hidden="true"></i>
        <h4>
            <slot>{{$t('NO_DATA_FOR_PREVIEW')}}</slot>
        </h4>
    </div>
</template>
<script>
    export default {
        name: "AppNoData",
        props: {
            icon: {
                type: String,
                default: 'fa fa-exclamation-triangle fa-fw fa-4x'
            }
        }
    }
</script>

<style scoped>
    .no-data-component {
        text-align: center;
        color: #acb4bc;
        margin-top: 10rem;
    }
</style>
